import * as SubframeCore from "@subframe/core";

export const INBOX_DATE_FILTER_OPTIONS = {
  "Last 7 days": {
    value: 7,
    label: "Last 7 days",
  },
  "Last 30 days": {
    value: 30,
    label: "Last 30 days",
  },
};

export const ROSTER_DATE_FILTER_OPTIONS = {
  "Last 7 days": {
    value: 7,
    label: "Last 7 days",
  },
  "Last 30 days": {
    value: 30,
    label: "Last 30 days",
  },
};

export const REPORTS_DATE_FILTER_OPTIONS = {
  "Last 7 days": {
    value: 7,
    label: "Last 7 days",
  },
  "Last 30 days": {
    value: 30,
    label: "Last 30 days",
  },
};

export const SENTIMENT = {
  Positive: {
    value: "high",
    icon: (
      <SubframeCore.Icon
        className="text-success-700 text-section-header font-section-header"
        name="FeatherSmile"
      />
    ),
    label: "High",
    avatarVariant: "success",
    sentimentBackgroundColor: "#dcfce7",
    sentimentTextColor: "#15803d",
  },
  Neutral: {
    value: "neutral",
    icon: (
      <SubframeCore.Icon
        className="text-neutral-700 text-section-header font-section-header"
        name="FeatherMeh"
      />
    ),
    label: "Neutral",
    avatarVariant: "warning",
    sentimentBackgroundColor: "#fef9c3",
    sentimentTextColor: "#a16207",
  },
  Negative: {
    value: "low",
    icon: (
      <SubframeCore.Icon
        className="text-error-700 text-section-header font-section-header"
        name="FeatherFrown"
      />
    ),
    label: "Low",
    avatarVariant: "error",
    sentimentBackgroundColor: "#fee2e2",
    sentimentTextColor: "#b91c1c",
  },
  "No Data": {
    value: "no-data",
    label: "No Data",
    icon: <></>, //TODO: Define the icon after subframe adds the No Data icon.
    avatarVariant: "neutral",
    sentimentBackgroundColor: "#f5f5f5",
    sentimentTextColor: "#404040",
  },
};

export const SORT_BY_OPTIONS = {
  "Oldest to Newest": {
    value: 1,
    label: "Oldest to Newest",
  },
  "Newest to Oldest": {
    value: -1,
    label: "Newest to Oldest",
  },
};

export const INBOX_ESCALATION_TYPE = {
  AT_RISK: "AT_RISK",
  RESOLVED: "RESOLVED",
  DISMISSED: "DISMISSED",
};

export const HISTORY_TYPE = {
  HIRED: {
    icon: (
      <SubframeCore.Icon
        className="text-neutral-600 text-body-bold font-body-bold"
        name="FeatherBuilding"
      />
    ),
    value: "HIRED",
    background: "bg-neutral-100",
  },
  SURVEY_COMPLETED: {
    icon: (
      <SubframeCore.Icon
        className="text-brand-600 text-body-bold font-body-bold"
        name="FeatherCheckCircle"
      />
    ),
    value: "SURVEY_COMPLETED",
    background: "bg-brand-100",
  },
  SURVEY_INCOMPLETE: {
    icon: (
      <SubframeCore.Icon
        className="text-error-600 text-body-bold font-body-bold"
        name="FeatherAlertCircle"
      />
    ),
    value: "SURVEY_INCOMPLETE",
    background: "bg-error-100",
  },
  ESCALATION_RAISED: {
    icon: (
      <SubframeCore.Icon
        className="text-error-600 text-body-bold font-body-bold"
        name="FeatherAlertTriangle"
      />
    ),
    value: "ESCALATION_RAISED",
    background: "bg-error-100",
  },
  ESCALATION_FOLLOWUP: {
    icon: (
      <SubframeCore.Icon
        className="text-brand-600 text-body-bold font-body-bold"
        name="FeatherMessageSquarePlus"
      />
    ),
    value: "ESCALATION_FOLLOWUP",
    background: "bg-brand-100",
  },
  ESCALATION_RESOLVED: {
    icon: (
      <SubframeCore.Icon
        className="text-success-600 text-body-bold font-body-bold"
        name="FeatherCheck"
      />
    ),
    value: "ESCALATION_RESOLVED",
    background: "bg-success-100",
  },
  ESCALATION_DISMISSED: {
    icon: (
      <SubframeCore.Icon
        className="text-neutral-600 text-body-bold font-body-bold"
        name="FeatherX"
      />
    ),
    value: "ESCALATION_DISMISSED",
    background: "bg-neutral-100",
  },
  SURVEY_SENT: {
    icon: (
      <SubframeCore.Icon
        className="text-brand-600 text-body-bold font-body-bold"
        name="FeatherSend"
      />
    ),
    value: "SURVEY_SENT",
    background: "bg-brand-100",
  },
  TERMINATED: {
    icon: (
      <SubframeCore.Icon
        className="text-error-600 text-body-bold font-body-bold"
        name="FeatherUserX"
      />
    ),
    value: "TERMINATED",
    background: "bg-error-100",
  },
  RECOGNITION_SENT: {
    icon: (
      <SubframeCore.Icon
        className="text-body-bold font-body-bold text-brand-700"
        name="FeatherArrowUpRight"
      />
    ),
    value: "RECOGNITION_SENT",
    background: "bg-brand-100",
  },
  RECOGNITION_RECEIVED: {
    icon: (
      <SubframeCore.Icon
        className="text-body-bold font-body-bold text-success-600"
        name="FeatherArrowDownLeft"
      />
    ),
    value: "RECOGNITION_RECEIVED",
    background: "bg-success-100",
  },
};

export const INBOX_TABS = ["At-risk", "Resolved", "Dismissed"];

export const ESCALATION_FOLLOW_UP_OUTCOME = {
  SUCCESSFUL: {
    label: "Resolved",
    value: "SUCCESSFUL",
  },
  ATTENTION_NEEDED: {
    label: "Needs Attention",
    value: "NEEDS_ATTENTION",
  },
  OTHER: {
    label: "Other",
    value: "OTHER",
  },
  DISMISSED: {
    label: "Dismissed",
    value: "DISMISS",
  },
};

export const ESCALATION_REASONS = {
  LOW_SENTIMENT_SCORE: {
    label: "Low Sentiment Score",
  },
  INCOMPLETE_SURVEY: {
    label: "Incomplete Survey",
  },
};

export const RECOGNITION_CATEGORY = {
  CLINICAL_EXCELLENCE: {
    label: "Clinical Excellence",
    value: "CLINICAL_EXCELLENCE",
  },
  TEAMWORK: {
    label: "Teamwork",
    value: "TEAMWORK",
  },
  PATIENT_SATISFACTION: {
    label: "Patient Satisfaction",
    value: "PATIENT_SATISFACTION",
  },
  PERSONAL_IMPROVEMENT: {
    label: "Personal Improvement",
    value: "PERSONAL_IMPROVEMENT",
  },
  COMMUNICATION: {
    label: "Communication",
    value: "COMMUNICATION",
  },
  OTHER: {
    label: "Other",
    value: "OTHER",
  },
};

export const RECOGNITION_DIRECTED_AT = {
  SUPERVISOR: {
    label: "Supervisor",
    value: "SUPERVISOR",
  },
  PEER: {
    label: "Peer",
    value: "PEER",
  },
  DIRECT_REPORT: {
    label: "Direct Report",
    value: "DIRECT_REPORT",
  },
};

export const RECOGNITION_TYPE = {
  RECEIVED: "RECEIVED",
  PROVIDED: "PROVIDED",
};

export const SURVEY_TYPE = {
  MULTIPLE_CHOICE: "multiple_choice",
  NUMERICAL: "numerical",
  FREE_RESPONSE: "free_response",
};
